import { Navigate, useLocation } from 'react-router'

// Rendered rather than run as a loader: by now the history holds the opened
// path, so `replace` drops that entry and not the page the user came from.
function RouteRedirectHome() {
  const { hash, search } = useLocation()

  return <Navigate replace to={`/${search}${hash}`} />
}

export default RouteRedirectHome
